import { isNil } from 'lodash';
import { metric } from '../../lib/metric';
import { PortfolioProjectCardProject } from './PortfolioProjectCard';

const EMPTY_FIELDS_REPORTED: (keyof PortfolioProjectCardProject)[] = [
    'description',
    'title',
    'price',
    'duration',
    'internalProjectDetails',
    'categoryDetails',
];

export const reportNullableFields = (project: PortfolioProjectCardProject) => {
    EMPTY_FIELDS_REPORTED.forEach((field) => {
        if (typeof field === 'object') {
            Object.keys(field).forEach((subField) => reportEmptyField(project, subField));
        } else {
            reportEmptyField(project, field);
        }
    });
};

const reportEmptyField = (project: PortfolioProjectCardProject, field: string) => {
    if (isNil(project[field])) {
        metric.count(`missing_from_portfolio_project.${field}`);
    }
};
